import { createScopedTranslationKeys } from '@dreryk/react-common';

export const translations = {
   pl: {
      '~libs.desktop.shared.visit-medical-documents.print-from-visit': {
         chooseDocumentToPrint: 'Wybierz co najmniej jeden dokument do druku',
         otherDocuments: 'Pozostałe dokumenty z wizyty (druki, recepty, skierowania, eZLA)',
         printingDocuments: 'Drukowanie dokumentów',
         recommendations: 'Zalecenia dla pacjenta',
         sharingDocumentation: 'Wysyłanie dokumentacji',
         subjectiveAssessment: 'Badanie przedmiotowe',
         visitSummary: 'Karta wizyty',
      },
   },
};

export const translationKeys = createScopedTranslationKeys(
   translations.pl,
   '~libs.desktop.shared.visit-medical-documents.print-from-visit'
);
